import React, { useState, useEffect } from 'react';
import { Typography } from '@tvg/fuse/typography';
import { LoadingSpinner } from '@tvg/fuse/loading-spinner';
import styles from './RatingsAndReviews.module.css';

type Props = {
  productId: string;
  BV_URL: string;
};

const Reviews = React.memo((props: Props) => {
  const { productId, BV_URL } = props;
  const [BVloading, setIsBVLoading] = useState(false);

  useEffect(() => {
    // Check if the script already exists
    const scriptExists = document.querySelector(`script[src="${BV_URL}"]`);
    if (!scriptExists) {
      setIsBVLoading(true); // Set loading state to true while the script loads
      const script = document.createElement('script');
      script.src = BV_URL;
      script.async = true;
      script.onload = () => {
        setIsBVLoading(false); // Update state once the script is loaded
      };
      document.head.appendChild(script);
    }
  }, []);

  return (
    <div className={styles.container} id="ratings-and-reviews" data-testid="ratings_and_reviews">
      <Typography className={styles.title} tag="h2" size="3">
        Customer reviews
      </Typography>

      {BVloading && (
        <div data-testid="ratings_and_reviews_loading">
          <LoadingSpinner size="small" variant="secondary" />
        </div>
      )}
      {!BVloading && (
        <div data-bv-show="reviews" data-bv-product-id={productId} data-testid="ratings_and_reviews_reviews" />
      )}
    </div>
  );
});

export default Reviews;
